<script>
    import Textfield from '@smui/textfield/styled';
    import HelperText from '@smui/textfield/helper-text/index';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import Select, { Option } from '@smui/select/styled';
    import GoogleMap from '../components/GoogleMap.svelte';
    import Datepicker from 'svelte-calendar';
    import { formatDate } from 'timeUtils'
    import * as yup from 'yup';    
    import Payment from "payment";
    import { navigate } from "svelte-routing";
    import { api_host } from "../stores.js";
    import { doAPIPost } from '../utils/Fetching.svelte';
    import { toast } from '@zerodevx/svelte-toast';


    let address_data = { address:"", city:"", state:"" };

    async function process_address(address_query_string){
        let res = false;
        const params = new URLSearchParams(address_query_string)

        if (params.has('address_data') === true) {
            try {
                let tdata = JSON.parse(atob(params.get('address_data')));
                if (tdata !== null && tdata['address']) {
                    address_data = tdata;
                    res = true;
                } else {
                    navigate("/");
                }
            } catch(e) {
                navigate("/");
            }
        } else {
            if (address_data.address === "") {
                navigate("/");
            }
        }

        return res;
    }

    process_address(window.location.search);

    const today = new Date();
    let dateFormat = '#{D}, #{M} #{j}, #{Y}';

    let tomorrow;
	$: {
	  const date = new Date(today);
	  date.setDate(date.getDate() + 1);
	  tomorrow = date;
	}

    let selectedDateFormatted = "";
    let selectedDate;
    let nextServiceDate;
    let nextServiceDateFormattedSimple = "00-00-0000";

    $: selectedDateFormattedSimple = (selectedDate === undefined) ? "00-00-0000" : formatDate(selectedDate,'#{m}-#{d}-#{Y}');

    function getNextDate(the_date){
        if(the_date !== undefined && service !== undefined) {
            const date = new Date(the_date.getTime());
            let bump_amount = 7;
            if(service === "Weekly") {
                bump_amount = 7;
            }
            if(service === "Bi-Weekly") {
                bump_amount = 14;
            }
            if(service === "Monthly") {
                bump_amount = 28;
            }

            if(service === "One-Time") {
                nextServiceDate = undefined;
            }else{
                date.setDate(date.getDate() + bump_amount);
                nextServiceDate = date;
            }
        }else{
            nextServiceDate = undefined;
        }
    }
    $: getNextDate(selectedDate, service);
    $: nextServiceDateFormattedSimple = (nextServiceDate === undefined) ? "00-00-0000" : formatDate(nextServiceDate,'#{m}-#{d}-#{Y}');

    let time_preference = "No Preference";
    const time_preferences_options= ['No Preference', '6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM' ];

    let lawn = "None";
    const lawn_options = ['None', 'Front OR Back', 'Front AND Back'];

    let service = "Weekly";
    const service_options = ['Weekly', 'Bi-Weekly', 'Monthly', 'One-Time'];

    let last_service = "Less than 2 weeks ago";
    const last_service_options = ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'];

    let back_yard_entry = "Other";
    const back_yard_entry_options = ['Already Open', 'Ring Door Bell', 'Not Required', 'Other'];

    let giftcard = "";

    let additional_comments = "";
    
    $: service_price = update_service_price(true, lawn, service, last_service, back_yard_entry)
    $: next_service_price = update_service_price(false, lawn, service, last_service, back_yard_entry)

    let pricing_factors = {
        // Margin Factors
        // client_margin: 1.35,
        client_margin: 1.7,
        contractor_margin: 0.8,
        // Yard Factors
        yard_factor_for_story_1: 0.38,
        yard_factor_for_story_gt_1: 0.45,
        lawn_factor_front_or_back: 1.0,
        lawn_factor_front_and_back: 1.083,
        lawn_factor_none: 0.95,
        service_one_time: 1.65,
        service_weekly: 0.74,
        service_bi_weekly: 0.89,
        service_monthly: 1.157,

        // Last Time Cleanup
        last_time_less_2_weeks: 0.98,
        last_time_2_4_weeks: 1.56,
        last_time_1_2_months: 2.5,
        last_time_3_months_or_more: 3.8,
        // Referrals
        referral_duration: 7,
        referral_discount: 10.0,
        // Discounts     
        discount_monthly_service: 0.3        
    }

    function update_service_price(is_first = true) {
        let origin_service_price = 40;
        if (lawn === 'None') {
            origin_service_price += 0;
        } else if (lawn === 'Front OR Back') {
            origin_service_price += 10;
        } else {
            origin_service_price += 20;
        }
        if (service === 'Weekly') {
            origin_service_price += 0;
        } else if (service === 'Bi-Weekly') {
            origin_service_price += 10;
        } else if (service === 'Monthly') {
            origin_service_price += 20;
        } else {
            origin_service_price += 30;
        }
        if (last_service === 'Less than 2 weeks ago') {
            origin_service_price += 0;
        } else if (last_service === '2 to 4 weeks ago') {
            origin_service_price += 20;
        } else if (last_service === '1 to 2 months ago') {
            origin_service_price += 40;
        } else {
            origin_service_price += 60;
        }
        if (!is_first) {
            origin_service_price -= 20;
        }
        
        return origin_service_price;

        //////////////// Helper functions
        function calculate_yard_factor(_stories, _lot_size, _service){
            return _stories === 1 ? pricing_factors.yard_factor_for_story_1 : pricing_factors.yard_factor_for_story_gt_1
        }

        function calculate_lawn_factor(_lawn, _bad_shape){
            let res = pricing_factors.lawn_factor_front_or_back;

            if(_lawn === "Front AND Back"){ res = pricing_factors.lawn_factor_front_and_back;}
            if(_lawn === "None"){ res = pricing_factors.lawn_factor_none;}

            return res;
        }

        function calculate_service_factor(_service_type, _lot_size, _last_time, _bad_shape){
            let res = {'Weekly': pricing_factors.service_weekly, 'Bi-Weekly':pricing_factors.service_bi_weekly, 'Monthly':pricing_factors.service_monthly, 'One-Time':pricing_factors.service_one_time}[_service_type];
            
            res *= {'Less than 2 weeks ago':pricing_factors.last_time_less_2_weeks, '2 to 4 weeks ago':pricing_factors.last_time_2_4_weeks, '1 to 2 months ago':pricing_factors.last_time_1_2_months, '3 months or more':pricing_factors.last_time_3_months_or_more}[_last_time];

            if(_bad_shape){res *= pricing_factors.last_time_bad_shape}


            return res;
        }

        function price_by_yard_size(_lot_size, _first=true) {
            if(_first) {
                return 0.006 + 0.021 * 4000 / _lot_size;
            }else{
                return 0.006 + 0.017 * 3000 / _lot_size;
            }
        }

        function pricing_formula(_lot_size = 0, _lawn = false, _service_type = "One-Time", _last_time=14, _stories=1, _bad_shape=null, _weed_removal=false, _weed_control=false, _first_service=true) {

            _lot_size = parseInt(_lot_size);
            _stories = parseInt(_stories);            

            let yard_factor = calculate_yard_factor(_stories, _lot_size, _service_type)
            let price_per_yard = price_by_yard_size(_lot_size, _first_service)
            let lawn_factor = calculate_lawn_factor(_lawn, _bad_shape)
            let service_factor = calculate_service_factor(_service_type, _lot_size, _last_time, _bad_shape)

            let price = yard_factor * _lot_size * price_per_yard * lawn_factor * service_factor
            

            let subtotal_price = (price * 1.2)
            subtotal_price = (subtotal_price * pricing_factors.client_margin);

            return subtotal_price.toFixed(2);
        }

        return pricing_formula(address_data.lot_size, lawn, service, last_service, address_data.building_stories, null, false, false, is_first);
    }

    const formSchema = yup.object().shape({
        first_name: yup
            .string()
            .required('First Name is Required'),
        last_name: yup
            .string()
            .required('Last Name is Required'),
        email: yup.string().required('This Field is Required').email('Invalid email'),
        home_phone: yup
            .string()
            .required('Home Phone is Required')
            .matches(/(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/, {
                message: 'Invalid phone number',
            }),
        mobile_phone: yup
            .string()
            .test('mobile-is-good', 'Invalid phone number.', value => {return (value === null || value.match(/^ *$/) !== null) || (value.match(/(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/));}),
        cc_name: yup
            .string()
            .required('This must match the name on your card.'),
        cc_number: yup
            .string()
            .required('This must match the number on your card.')
            .test('cc-is-good', 'Card number is invalid.', value => Payment.fns.validateCardNumber(value)),
        cc_expiry: yup
            .string()
            .required('Expiration date is required')
            .max(5, 'Not a valid expiration date. Example: MM/YY')
            .matches(
                /([0-9]{2})\/([0-9]{2})/,
                'Not a valid expiration date. Example: MM/YY'
            )
            .test('expiry-is-good', 'Expiration date is invalid.', value => Payment.fns.validateCardExpiry(value)),
        cc_cvc: yup
            .string()
            .required('This is a 3 or 4 digit number.')
            .min(3, 'Must be at least 3 digits.')
            .max(4, 'Must be a 3 or 4 digit number.')
            .matches(
                /^[0-9]{3,4}$/,
                'Code must be a 3 or 4 digit number.'
            ),
    });
    $: full_name = `${field_data.first_name} ${field_data.last_name}`
    $: {
        if('cc_expiry' in field_data && field_data.cc_expiry !== undefined && field_data.cc_expiry.length > 2) {
            let tmp_expiry = field_data.cc_expiry.replace(/\D/g,'');
            if(tmp_expiry.length > 1) {
                tmp_expiry = tmp_expiry.slice(0, 2) + "/" + tmp_expiry.slice(2);
            }
            if(tmp_expiry.length > 5){
                tmp_expiry = tmp_expiry.substring(0, 5)
            }
            field_data.cc_expiry = tmp_expiry;
        }
    }
    // load up watched fields
    let field_data = {};
    for (let nk in formSchema.describe().fields){
        field_data[nk] = "";
        field_data[`${nk}_iv`] = false;
        field_data[`${nk}_h`] = "";
    }

    function resetFieldData() {
        for (let nk in formSchema.describe().fields){
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = "";
        }
    }

    async function validateForm() {
        resetFieldData();
        let res = true;
        for (let nk in formSchema.describe().fields){
            await formSchema.validateAt(nk, field_data, {
                abortEarly: true  
            }).catch((err) => {
                field_data[`${nk}_iv`] = true;
                field_data[`${nk}_h`] = err.errors[0];
                res = false;
            });
        }
        return res;
    }

    let disable_send = false;
    
    async function doBookJob() {
        if(await validateForm()) {
            disable_send = true;
            const turl = api_host + "/api/book_appointment";
            const payload = {
                "address": address_data.address,
                "city": address_data.city,
                "state": address_data.state,
                "zipcode": address_data.zipcode,
                "service_date": selectedDateFormattedSimple,
                "next_service_date": nextServiceDateFormattedSimple,
                "time_preference": time_preference,
                "lawn": lawn,
                "service": service,
                "last_service": last_service,
                "back_yard_entry": back_yard_entry,
                "first_name": field_data.first_name,
                "last_name": field_data.last_name,
                "full_name": full_name,
                "email": field_data.email,
                "mobile_phone": field_data.mobile_phone,
                "home_phone": field_data.home_phone,
                "service_price": service_price,
                "next_service_price": next_service_price,
                "giftcard": giftcard,
                "additional_comments": additional_comments           
            };
            const headers = {'Content-Type': 'application/json', "Cc-Info": JSON.stringify({
                cc_name: field_data.cc_name, 
                cc_number: field_data.cc_number, 
                cc_cvc: field_data.cc_cvc, 
                cc_expiry: field_data.cc_expiry
            })};

            let res = await doAPIPost(turl, "Booking your lawn service appointment...", "Appoinment booked! Check your email for confirmation.", payload, headers, 10000);
            disable_send = false;
            if(res.st === true) {

                setTimeout(()=>{
                    navigate("/");
                }, 6000);                    

            }
        } else {
            toast.push("Please fill out all required fields", {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }
    }

</script>

<div class="formholder">
    <div class="serviceinformation infocard">
        <div class="title">Service Information (Sample Only)</div>
        <!-- <div class="ff address">
            <Textfield
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.address}
                disabled 
                label="Address">
            </Textfield>            
        </div>

        <div class="ff city">
            <Textfield 
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.city}
                disabled
                label="City">
            </Textfield>            
        </div>
        
        <div class="ff state">
            <Textfield 
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="filled" 
                bind:value={address_data.state}
                disabled
                label="State">
            </Textfield>            
        </div> -->
        
        <div class="ff dayofservice">
            <Datepicker 
                buttonBackgroundColor='#00b300'
                buttonTextColor='white'
                start={tomorrow}
                format='{dateFormat}'
                bind:formattedSelected={selectedDateFormatted}
                bind:selected={selectedDate}
            >
            </Datepicker>
        </div>
        
        <div class="ff timepreference">
            <Select 
            variant="outlined" 
            style="width: 100%;"
            bind:value={time_preference} 
            label="Time Preference">
                {#each time_preferences_options as tp}
                  <Option value={tp}>{tp}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff lawn">
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={lawn} 
                label="Lawn"
            >
                {#each lawn_options as lo}
                  <Option value={lo}>{lo}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff service">
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={service} 
                label="Service"
            >
                {#each service_options as so}
                  <Option value={so}>{so}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff lastservice">
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={last_service} 
                label="Last Service"
            >
                {#each last_service_options as lso}
                  <Option value={lso}>{lso}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff backyardentry">
            <Select 
                variant="outlined" 
                style="width: 100%;"
                bind:value={back_yard_entry} 
                label="Back Yard Entry Instructions"
            >
                {#each back_yard_entry_options as byeo}
                  <Option value={byeo}>{byeo}</Option>
                {/each}
            </Select>
        </div>
        
        <div class="ff giftcard">
            <Textfield 
                style="width: 100%;"
                helperLine$style="width: 100%;" 
                variant="outlined" 
                bind:value={giftcard} 
                label="Coupon Code"
            >
                <HelperText slot="helper">If you have a coupon code, enter it here.</HelperText>
            </Textfield>            
        </div>
        
        <div class="ff additionalcomments">
            <Textfield 
                textarea 
                input$maxlength="1000" 
                style="width: 100%; height: 100%"
                bind:value={additional_comments}  
                label="Additional Comments"
            >
                <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
            </Textfield>
        </div>
    </div>

    <div class="serviceprice infocard">
        <div class="title">Service Price</div>
        <div class="serviceinfoservice">First Service</div>
        <div class="serviceinfoprice">${service_price}</div>
        <div class="serviceinfohr"><hr /></div>
        <div class="serviceinforow"><div class="serviceinforowtitle">Service Type:</div><div class="serviceinforowvalue">{service}</div></div>
        <div class="serviceinforow"><div class="serviceinforowtitle">Service Date:</div><div class="serviceinforowvalue">{selectedDateFormattedSimple}</div></div>
        {#if nextServiceDate !== undefined}
            <div class="serviceinforow"><div class="serviceinforowtitle">Next Service Price:</div><div class="serviceinforowvalue highlightvalue">${next_service_price}</div></div>
            <div class="serviceinforow"><div class="serviceinforowtitle">Next Service Date:</div><div class="serviceinforowvalue">{nextServiceDateFormattedSimple}</div></div>
        {/if}        
        <!-- <div div class="giftcardlink"><a href="/#/giftcards?value={service_price}"><i class="fas fa-gift"></i> Send this service as a Gift Card</a></div> -->

    </div>

    <div class="location infocard">
        <div class="title">Location</div>
        <div class="locationmapholder">
            <GoogleMap address={address_data.address} city={address_data.city} state={address_data.state} />
        </div>
    </div>
</div>

<style>
    .formholder {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        /* background-color: lime; */
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-template-rows: 13fr;
        grid-template-areas: "si sp"
                             "si sp"
                             "si sp"
                             "si lo"
                             "si lo"
                             "si lo"
                             "si . "
                             "ci . "
                             "ci . "
                             "ci . "
                             "pi . "
                             "pi . "
                             "bb . ";
        gap: 25px;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .formholder {
            width: 100%;
            /* background-color: lime; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 6fr;
            grid-template-areas: "si"
                                 "ci"
                                 "sp"
                                 "pi"
                                 "bb"
                                 "lo";
        }
    }

    /* globals */
    .ff {
        padding: 10px;
    }
    .title {
        font-size: 23px;
        font-weight: bold;
    }
    .infocard {
        background-color: #E9E9EC;
        /* margin-bottom: 25px; */
    }
    .infocard > .title {
        background-color: white;
        padding-bottom: 20px;
    }

    /* service information  */
    .serviceinformation {
        grid-area: si;
        /* background-color: red; */
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        /* grid-template-rows: 30px repeat(7, 1fr); */
        grid-template-areas: "ti ti ti ti ti ti"
                             "ad ad ct ct st st"
                             "ds ds ds tp tp tp"
                             "la la la ss ss ss"
                             "ls ls ls ls ls ls"
                             "by by by gc gc gc"
                             "ac ac ac ac ac ac"
                             "ac ac ac ac ac ac";
    }

    @media (max-device-width: 1024px), (max-width: 1023px) { 
        .serviceinformation {
            width: 100%;
            /* background-color: lime; */
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 11fr;
            grid-template-areas: "ti"
                                 "ad"
                                 "ct"
                                 "st"
                                 "ds"
                                 "tp"
                                 "la"
                                 "ss"
                                 "ls"
                                 "by"
                                 "gc"
                                 "ac";
        }
    }

    .serviceinformation > .title {
        grid-area: ti;
    }
    .serviceinformation > .address {
        grid-area: ad;
    }
    .serviceinformation > .city {
        grid-area: ct;
    }
    .serviceinformation > .state {
        grid-area: st;
    }
    .serviceinformation > .dayofservice {
        grid-area: ds;
    }
    * :global(.datepicker) {
        width: 100% !important;
        height: 100%;
    }
    * :global(.calendar-button) {
        width: 90% !important;
        margin-left: auto;
        margin-right: auto;
        border: 1px solid black !important;
    }
    * :global(.calendar-button::after) {
        /* display: inline-block; */
        /* font-style: normal; */
        /* font-variant: normal; */
        /* text-rendering: auto; */
        /* -webkit-font-smoothing: antialiased; */
        /* font-family: fontAwesome; */
        /* content: "\f133"; */
        /* content: url(/img/calendar-alt-solid.png); */
        background-image: url('/img/calendar-alt-solid.png');
        background-size: 16px 16px;
        display: inline-block;
        width: 16px; 
        height: 16px;
        content:"";
        /* transform: scale(.2); */
        margin-left: 5px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) { 
        * :global(.calendar-button::after) {
            background-image: url('/img/calendar-alt-solid.png');
            background-size: 16px 16px;
            display: inline-block;
            width: 16px; 
            height: 16px;
            content:"";
            margin-left: 5px;
        }

    }
    * :global(.calendar-button::before) {
        display: inline-block;
        font-style: normal;
        font-weight: bold;
        font-variant: normal;
        text-rendering: auto;
        /* -webkit-font-smoothing: antialiased; */
        /* font-family: fontAwesome; */
        content: "Service Date:";
        margin-right: 25px;
    }

    .serviceinformation > .timepreference {
        grid-area: tp;
    }

    .serviceinformation > .lawn {
        grid-area: la;
    }

    .serviceinformation > .service {
        grid-area: ss;
    }

    .serviceinformation > .lastservice {
        grid-area: ls;
    }

    .serviceinformation > .backyardentry {
        grid-area: by;
    }

    .serviceinformation > .giftcard {
        grid-area: gc;
    }

    .serviceinformation > .additionalcomments {
        grid-area: ac;
    }
   

    /* service price */
    .serviceprice {
        grid-area: sp;
        /* background-color: blue; */
        display: flex;
        flex-direction: column;
        /* justify-content: space-around; */
    }

    .serviceprice > .serviceinfoservice {
        font-size: 20px;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10px;
    }
    
    .serviceprice > .serviceinfoprice {
        font-size: 32px;
        font-weight: bold;
        padding: 10px;
    }
    
    .serviceprice > .serviceinfohr {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    
    .serviceprice > .serviceinfohr > hr {
        color: rgba(0,0,0,0.2);
    }

    .serviceinforow {
        font-size: 17px;
        display: flex;
        width: 100%;
        /* padding: 10px; */
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .serviceinforow > .serviceinforowtitle { 
        font-weight: bold;
        text-align: left;
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .serviceinforow > .serviceinforowvalue { 
        text-align: right;
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
        font-weight: lighter;
    }

    .highlightvalue {
        font-weight: bold !important;
    }

    .serviceprice > .giftcardlink{
        background-color: white !important;
        text-align: center;
    }

    .serviceprice > .giftcardlink a{
        color: green;
    }

    /* location */
    .location {
        grid-area: lo;
        /* background-color: purple; */
        height: 300px;
    }

    .locationmapholder {
        width: 100%;
        height: 300px;
    }

</style>